import { useQuery } from '@tanstack/react-query';
import { schedulingApi, servicesApi } from '../../lib/api.js';

/// Consultas e opções usadas pelas várias áreas da agenda.

export interface SchedulingCapabilities {
  canCreate: boolean;
  canUpdate: boolean;
  canCancel: boolean;
  canManageResources: boolean;
  canManageBlocks: boolean;
  /// Feriados são configuração da agenda (scheduling.settings.manage, ADR 0087).
  canManageHolidays?: boolean;
  /// Decidir a devolução que falhou no provedor mexe no pagamento da venda (sales.payments.manage).
  canDecidePortalRefund?: boolean;
}

/// Profissionais e salas ativos, na ordem do nome. A mesma consulta serve a todas as áreas, então
/// trocar de aba não pede a lista de novo.
export function useResourceOptions() {
  return useQuery({
    queryKey: ['company', 'scheduling', 'resource-options'],
    queryFn: () =>
      schedulingApi.listResources({
        activity: 'ACTIVE',
        kind: 'ALL',
        sort: 'displayName',
        direction: 'asc',
      }),
    retry: false,
  });
}

/// Serviços ativos. O catálogo é pequeno por natureza, e a escolha filtra a lista inteira na tela.
export function useServiceOptions() {
  return useQuery({
    queryKey: ['company', 'scheduling', 'service-options'],
    queryFn: () =>
      servicesApi.list({
        activity: 'ACTIVE',
        currency: 'ALL',
        sort: 'displayName',
        direction: 'asc',
        limit: 100,
        offset: 0,
      }),
    retry: false,
  });
}

export function optionList(items: Array<{ id: string; displayName: string }>, emptyLabel: string) {
  return [
    { value: '', label: emptyLabel },
    ...items.map((item) => ({ value: item.id, label: item.displayName })),
  ];
}
